import ProductSpecificationProvider from './hooks/useProductSpecification';

import { ProductSpecificationProps } from './@types/ProductSpecificationProps';

const ProductSpecification = (props: ProductSpecificationProps) => {
	return (
		<ProductSpecificationProvider {...props}>
			{Array(6)
				.fill(0)
				.map((_, index) => props.children)}
		</ProductSpecificationProvider>
	);
};

export default ProductSpecification;
